import React from 'react';

const Countdown = ({ timeRemaining }) => {
  let percentWidth = Math.floor(((60 - timeRemaining) / 60) * 100);
  // console.log(percentWidth);

  return (
    <div className='countdown-container'>
      <span className='countdown-span'>{timeRemaining}</span>
      <div
        className='countdown-bar'
        style={{ width: percentWidth + '%' }}
      ></div>
    </div>
  );
};

export default Countdown;

//
//
